<template>
  <div>
    <ProductsPDF
      ref="html2Pdf"
      @hasDownloaded="hasDownloaded()"
      :productsData="productsData"
    />
    <QrsPricesPDF
      ref="html2PdfQr"
      @hasDownloaded="hasDownloaded()"
      :productsData="productsData"
    />
    <ProductsImages
      :productsData="productsDataImages"
      :enableDownload="enableImagesDownload"
      @disable="disableDownloadImages()"
    />
    <v-dialog
      persistent
      :value="productSelectionPopup"
      @keydown.esc="closeModal()"
      width="700"
    >
      <v-card>
        <loading-block class="pt-8" v-if="!loaded"></loading-block>
        <div v-else>
          <v-card-title class="pb-0 mb-4">Generate PDF</v-card-title>
          <v-card-text>
            <v-text-field prepend-icon="mdi-magnify" placeholder="Search By Product" v-model="search"></v-text-field>
            <h4 class="text-center" v-if="!filteredCategories.length">
              No products found!
            </h4>
            <template v-else>
              <v-list-group
                ref="mainListGroup"
                :value="false"
                append-icon=""
                v-for="item in filteredCategories"
                :key="item.id"
                :id="item.id"
                :disabled="true"
              >
                <template v-slot:activator>
                  <v-checkbox
                    :value="item.id"
                    hide-details
                    class="mb-0 mt-0 custom-checkbox"
                    v-model="activeCategories"
                    @click="toggleCategory(item.id)"
                    :indeterminate="
                      totalActiveProductsByCat[item.id] > 0 &&
                        totalActiveProductsByCat[item.id] <
                          totalProductsByCat[item.id]
                    "
                  ></v-checkbox>
                  <v-list-item-title class="pt-1 ml-12 my-2 d-flex flex-column">
                    <div class="mb-2 d-flex justify-space-between align-center">
                      <h4>{{ item.name }}</h4>
                      <v-list-item-icon
                        class="my-0"
                        @click.stop="handleMainListGroup(item.id)"
                        style="z-index: 2;"
                      >
                        <v-icon>
                          mdi-menu-down
                        </v-icon>
                      </v-list-item-icon>
                    </div>
                    <div class="d-flex justify-space-between align-center">
                      <h4>{{ item.sku }}</h4>
                      <v-spacer />
                      <small>
                        Main Category
                      </small>
                    </div>
                  </v-list-item-title>
                </template>
                <v-list-item
                  v-for="product in item.products"
                  :key="product.id"
                  class="ml-10"
                  link
                >
                  <v-checkbox
                    hide-details
                    class="mb-0 mt-0 custom-checkbox"
                    :value="product.id"
                    v-model="activeProductIds"
                    @click="toggleProduct(product.id, item.id)"
                  ></v-checkbox>
                  <v-list-item-title class="pt-1 ml-11 my-2 d-flex flex-column">
                    <div class="d-flex justify-space-between align-center">
                      <h4 class="mb-2">{{ product.name }}</h4>
                    </div>
                    <div class="d-flex justify-space-between align-center">
                      <h4>SKU: {{ product.sku }}</h4>
                    </div>
                  </v-list-item-title>
                </v-list-item>
              </v-list-group>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              @click="closeModal()"
              color="white"
              class="mx-2"
              style="text-transform: capitalize;"
            >
              Cancel
            </v-btn>
            <v-btn
              v-if="vg_productSelectionType === 'pdf'"
              @click="generatePDF('item')"
              color="white primary"
              class="mx-2"
              style="text-transform: capitalize;"
            >
              Generate
            </v-btn>
            <v-btn
            v-if="vg_productSelectionType === 'image'"
              @click="generatePDF('image')"
              color="white primary"
              class="mx-2"
              style="text-transform: capitalize;"
              :disabled="!imageDownloadButton"
            >
              Download Images
            </v-btn>
            <v-btn
              v-if="vg_productSelectionType === 'pdf'"
              @click="generatePDF('qr')"
              color="white"
              :class="
                $vuetify.breakpoint.width > 960
                  ? 'ml-0 mr-0 primary'
                  : 'ml-0 primary'
              "
              style="text-transform: capitalize;"
            >
              QR Prices PDF
            </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { LocationProductAPI } from '@/clients/location/location.product.api'
import { LocationCategoryAPI } from '@/clients/location/location.category.api'
import LoadingBlock from '@/components/custom-components/LoadingBlock.vue'
import ProductsImages from './ProductsImages.vue'
import { mapActions, mapGetters } from 'vuex'
import ProductsPDF from './ProductsPDF.vue'
import QrsPricesPDF from './QrsPricesPDF.vue'
export default {
  components: {
    LoadingBlock,
    ProductsPDF,
    QrsPricesPDF,
    ProductsImages
  },
  data() {
    return {
      activeProductIds: [],
      categories: [],
      categoriesBackup: [],
      activeCategories: [],
      totalProductsByCat: {},
      totalActiveProductsByCat: {},
      loaded: false,
      productsData: [],
      productsDataImages: [],
      listItem: [],
      search: '',
      headers: [{ text: 'Product Name', value: 'name' }],
      enableImagesDownload: false,
      imageDownloadButton: true
    }
  },
  async mounted() {
    await this.getLocationProductList()
    this.checkboxesReset()
    this.loaded = true
  },
  watch: {
    selectedLocation(value) {
      if (value.id) {
        this.getLocationProductList()
      } else {
        this.listItem = []
      }
    },
    search: function(value) {
      this.categoryAdjuster()
      if (value !== '') {
        this.categories = this.categories.filter(item =>
          item.products.some(product => product.name.slice(0, value.length).toLowerCase() === value.toLowerCase())
        )
        this.categories.forEach(category => {
          category.products = category.products.filter(
            item => item.name.slice(0, value.length).toLowerCase() === value.toLowerCase()
          )
        })
      }
      this.checkboxesReset()
    }
  },
  computed: {
    ...mapGetters({
      productSelectionPopup: 'locationproduct/productSelectionPopup',
      vg_productSelectionType: 'locationproduct/productSelectionType',
      selectedLocation: 'location/selected'
    }),
    filteredCategories() {
      return this.categories
    }
  },
  methods: {
    disableDownloadImages() {
      this.imageDownloadButton = true
      this.enableImagesDownload = false
    },
    async closeModal() {
      this.setProductSelectionType('pdf')
      this.setProductSelectionPopup(false)
      this.enableImagesDownload = false
    },
    filterCategoryProducts(category) {
      return category
      // return {
      //   ...category,
      //   products: Array.isArray(category.products)
      //     ? category.products.filter(
      //       product => product.product_family !== 'cannabis'
      //     )
      //     : category.products
      // }
    },
    isEmptyCategory(category) {
      if (Array.isArray(category.products) && category.products.length === 0) {
        if (Array.isArray(category.sub_categories)) {
          return category.sub_categories.every(cat => cat.products.length === 0)
        } else {
          return true
        }
      } else {
        return false
      }
    },
    filterCategories(categories) {
      let data = []
      for (let cat of categories) {
        if (this.isEmptyCategory(this.filterCategoryProducts(cat))) continue
        let subCategories = []
        if (Array.isArray(cat.sub_categories)) {
          for (let subCat of cat.sub_categories) {
            if (this.isEmptyCategory(this.filterCategoryProducts(subCat))) {
              continue
            }
            subCategories.push({ ...this.filterCategoryProducts(subCat) })
          }
        }
        data.push({
          ...this.filterCategoryProducts(cat),
          sub_categories: subCategories
        })
      }
      return data
    },
    async getLocationProductList() {
      try {
        this.spinner(true)
        if (this.selectedLocation.id !== undefined) {
          // const locationProduct = await LocationProductAPI.fetch(this.selectedLocation.id)
          let { data: { payload } } = await LocationCategoryAPI.fetchCategoryProducts(
            this.selectedLocation.id,
            {
              include_products: 1,
              include_cannabis_attributes: 1,
              include_variants: 1,
              include_thc_cbd: 1,
              include_aromas: 1,
              include_terpenes: 1,
              include_brands: 1,
              available: 'all'
            }
        )
          payload = this.filterCategories(payload)
          payload = payload.sort((a, b) => a.name.localeCompare(b.name))
        this.categories = payload
        this.categoriesBackup = JSON.parse(JSON.stringify(payload))
        } else {
          this.listItem = []
        }
        this.spinner(false)
      } catch (err) {
        this.spinner(false)
        this.listItem = []
      }
    },
    async generatePDF(value) {
      try {
        this.spinner(true)
        // let arr = this.products_data.map(data => data.id)
        const {
          data: { payload }
        } = await LocationProductAPI.fetchProductDetails({
          product_ids: [...this.activeProductIds]
        })
        // this.productsData = payload
        if (value === 'item') {
          this.productsData = payload
          await this.genPdf()
          this.closeModal()
        } else if (value === 'qr') {
          this.productsData = payload
          await this.genQrOnlyPdf()
          this.closeModal()
        } else {
          this.productsDataImages = payload
          this.enableImagesDownload = true
          this.imageDownloadButton = false
        }
        this.spinner(false)
      } catch (err) {
        this.spinner(false)
      }
    },
    async genPdf() {
      this.loaded = false
      await this.$refs.html2Pdf.generatePdf()
    },
    async genQrOnlyPdf() {
      this.loaded = false
      await this.$refs.html2PdfQr.generatePdf()
    },
    hasDownloaded() {
      this.loaded = true
    },
    ...mapActions({
      setProductSelectionPopup: 'locationproduct/setProductSelectionPopup',
      setProductSelectionType: 'locationproduct/setProductSelectionType'
    }),
    checkboxesReset() {
      this.categories.forEach(category => {
        this.totalProductsByCat[category.id] = category.products.length
        this.totalActiveProductsByCat[category.id] = 0
        category.products.forEach(product => {
          if (this.activeProductIds.includes(product.id)) {
            this.totalActiveProductsByCat[category.id] += 1
          }
        })
        if (this.totalActiveProductsByCat[category.id] === this.totalProductsByCat[category.id]) {
          this.activeCategories.push(category.id)
        }
      })
    },
    categoryAdjuster() {
      this.categories = JSON.parse(JSON.stringify(this.categoriesBackup))
      // if (this.sortByCategory.length === 0) {
      //   this.categories = temp
      // } else {
      //   this.categories = temp.filter(item =>
      //     this.sortByCategory.includes(item.name)
      //   )
      // }
    },
    toggleCategory(cateId) {
      if (this.activeCategories.includes(cateId)) {
        this.totalActiveProductsByCat[cateId] = this.totalProductsByCat[cateId]
        this.categories.forEach(item => {
          if (item.id === cateId) {
            item.products.forEach(product => {
              if (!this.activeProductIds.includes(product.id)) {
                this.activeProductIds.push(product.id)
              }
            })
          }
        })
      } else {
        this.totalActiveProductsByCat[cateId] = 0
        this.categories.forEach(item => {
          if (item.id === cateId) {
            item.products.forEach(product => {
              if (this.activeProductIds.includes(product.id)) {
                this.activeProductIds = this.activeProductIds.filter(function(value) {
                  return value !== product.id
                })
              }
            })
          }
        })
      }
    },
    toggleProduct(productId, cateId) {
      if (this.activeProductIds.includes(productId)) {
        this.totalActiveProductsByCat[cateId]++
        if (
          this.totalProductsByCat[cateId] ===
          this.totalActiveProductsByCat[cateId]
        ) {
          this.activeCategories.push(cateId)
        }
      } else {
        this.totalActiveProductsByCat[cateId]--
        if (
          this.totalProductsByCat[cateId] - 1 ===
          this.totalActiveProductsByCat[cateId]
        ) {
          this.activeCategories = this.activeCategories.filter(function(value) {
            return value !== cateId
          })
        }
      }
    },
    ...mapActions({
      va_fetchProductCount: 'program/fetchProductCount'
    }),
    handleMainListGroup(id) {
      this.$refs.mainListGroup.forEach(element => {
        if (element.attrs$.id === id) {
          if (!element.isActive) {
            element.isActive = true
          } else if (element.isActive) {
            element.isActive = false
          }
        }
      })
    },
    handleSubListGroup(catId) {
      this.$refs.subListGroup.forEach(element => {
        if (element.attrs$.id === catId) {
          if (!element.isActive) {
            element.isActive = true
          } else if (element.isActive) {
            element.isActive = false
          }
        }
      })
    }
  }
}
</script>
